/* eslint-disable import/prefer-default-export */

import { TableRowProps, useTheme } from "@chakra-ui/react";
import { transparentize } from "@chakra-ui/theme-tools";

export function useColorTransparency(color: string, opacity: number) {
  const theme = useTheme();
  return transparentize(color, opacity)(theme);
}

export const SELECTABLE_ROW_STYLES: Omit<Partial<TableRowProps>, "key"> = {
  transition: "backgroundColor 200ms",
  cursor: "pointer",
  _hover: {
    backgroundColor: "gray.200",
    "> td > .chakra-checkbox, > td > .chakra-radio": {
      borderColor: "gray.300",
    },
  },
  _selected: {
    backgroundColor: "magenta.dark",
    color: "white",
  },
};
